import { Link } from 'react-router-dom';
import usePageMeta from '../components/usePageMeta';

const products = [
  {
    to: '/products/oneschool-companion',
    tag: 'AC',
    color: 'linear-gradient(135deg,#2f6fed,#16294a)',
    status: 'live',
    name: 'OneSchool Companion',
    blurb:
      'A desktop productivity app teachers install on their work or home computer to cut down on daily admin.',
  },
  {
    to: '/products/voceda',
    tag: 'VO',
    color: 'linear-gradient(135deg,#f5a524,#b8720b)',
    status: 'live',
    name: 'Voceda',
    blurb:
      'A web app at voceda.com for generating classroom-ready teaching and learning resources in minutes.',
  },
  {
    to: '/products/smstutor',
    tag: 'ST',
    color: 'linear-gradient(135deg,#1c8a56,#0f1c30)',
    status: 'soon',
    name: 'SMS Tutor',
    blurb:
      'A coming-soon web platform at smstutor.com for parents and guardians to arrange tutoring support for their kids.',
  },
];

function Home() {
  usePageMeta(
    'Software for Educators and Students',
    'Australia College builds practical software for classrooms — teacher productivity tools, resource generators, and student tutoring platforms.'
  );

  return (
    <>
      <section className="hero section--dark">
        <div className="container hero-grid">
          <div>
            <span className="eyebrow">Australia College</span>
            <h1>Technology that gives teachers their time back.</h1>
            <p className="hero-lead">
              We build focused, practical software for classrooms — so
              educators spend less time on admin and more time teaching, and
              students get better support along the way.
            </p>
            <div className="hero-actions">
              <Link to="/products" className="btn btn-amber">
                Explore our products
              </Link>
              <Link to="/contact" className="btn btn-secondary">
                Get in touch
              </Link>
            </div>
          </div>

          <div className="hero-panel">
            <div className="hero-panel-row">
              <span className="hero-panel-icon">1</span>
              <div>
                <h4>OneSchool Companion</h4>
                <p>Desktop productivity app for teachers.</p>
              </div>
            </div>
            <div className="hero-panel-row">
              <span className="hero-panel-icon">2</span>
              <div>
                <h4>Voceda</h4>
                <p>Generate teaching resources at voceda.com.</p>
              </div>
            </div>
            <div className="hero-panel-row">
              <span className="hero-panel-icon">3</span>
              <div>
                <h4>SMS Tutor</h4>
                <p>Tutoring support for students — coming soon.</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="section">
        <div className="container">
          <div className="section-head center">
            <span className="eyebrow">What we build</span>
            <h2>Software for the whole school community</h2>
            <p>
              Every product we make is aimed at one thing: reducing the
              amount of time educators, students and families spend on the
              busywork around learning — so there's more time for the
              learning itself.
            </p>
          </div>

          <div className="grid grid-3">
            {products.map((p) => (
              <Link to={p.to} className="card" key={p.to}>
                <div className="card-top-row">
                  <div className="card-icon" style={{ background: p.color }}>
                    {p.tag}
                  </div>
                  <span className={`badge badge--${p.status === 'live' ? 'live' : 'soon'}`}>
                    {p.status === 'live' ? 'Available' : 'Coming soon'}
                  </span>
                </div>
                <h3>{p.name}</h3>
                <p>{p.blurb}</p>
                <span className="card-link">Learn more →</span>
              </Link>
            ))}
          </div>
        </div>
      </section>

      <section className="section section--alt">
        <div className="container">
          <div className="section-head center">
            <span className="eyebrow">Why Australia College</span>
            <h2>Built around real classroom workflows</h2>
          </div>

          <div className="grid grid-3">
            <div className="card">
              <h3>Practical, not flashy</h3>
              <p>
                We design for the tasks educators actually do every day —
                lesson prep, resource creation, admin — not for feature
                checklists.
              </p>
            </div>
            <div className="card">
              <h3>Shaped by feedback</h3>
              <p>
                Our roadmap is driven by what teachers, students and
                families tell us they need, and we keep iterating from
                there.
              </p>
            </div>
            <div className="card">
              <h3>Privacy-conscious</h3>
              <p>
                Education data deserves care. We keep our tools focused and
                avoid collecting more than is needed to do the job.
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className="section">
        <div className="container">
          <div className="cta-banner">
            <div>
              <h2 style={{ marginBottom: 8 }}>Curious about what we're building?</h2>
              <p>Reach out and we'll get back to you — no account needed.</p>
            </div>
            <div className="cta-banner-actions">
              <Link to="/products" className="btn btn-secondary">
                See products
              </Link>
              <Link to="/contact" className="btn btn-amber">
                Contact us
              </Link>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default Home;
